import React from "react";
import { type Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripePaymentIntentCompletedMessage from "./StripePaymentIntentCompletedMessage";
import Panel from "../../components/panels/panel";

interface StripeSetupIntentCompletePanelProps {
  stripe: Promise<Stripe>;
  viewModel: server.viewmodel.SubscriptionPaymentSetupCompleteFrontModel;
}

const StripeSetupIntentCompletePanel = ({ stripe, viewModel }: StripeSetupIntentCompletePanelProps) => {
  return (
    <Panel
      title={RESX.Payment.PaymentMethod}>
      <Elements stripe={stripe}>

        <div className="margin-bottom-huge">
          <StripePaymentIntentCompletedMessage />
        </div>
        <div className="flex justify-end">
          <a href={viewModel.subscriptionPageUrl} className="button-new tertiary">{RESX.Buttons.BtnOk}</a>
        </div>

      </Elements>
    </Panel >
  );
};

export default StripeSetupIntentCompletePanel;